import n from "./index49.js";
import p from "./index60.js";
const D = 100;
function m(e) {
  return n.isPlainObject(e) || n.isArray(e);
}
function F(e) {
  return n.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function E(e, s, f) {
  return e ? e.concat(s).map(function(c, u) {
    return c = F(c), !f && u ? "[" + c + "]" : c;
  }).join(f ? "." : "") : s;
}
function S(e) {
  return n.isArray(e) && !e.some(m);
}
const U = n.toFlatObject(n, {}, null, function(s) {
  return /^is[A-Z]/.test(s);
});
function P(e, s, f) {
  if (!n.isObject(e))
    throw new TypeError("target must be an object");
  s = s || new FormData(), f = n.toFlatObject(
    f,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(i, r) {
      return !n.isUndefined(r[i]);
    }
  );
  const B = f.metaTokens, c = f.visitor || x, u = f.dots, O = f.indexes, h = f.Blob || typeof Blob < "u" && Blob, a = f.maxDepth === void 0 ? D : f.maxDepth, A = h && n.isSpecCompliantForm(s), w = [];
  if (!n.isFunction(c))
    throw new TypeError("visitor must be a function");
  function b(t) {
    if (t === null)
      return "";
    if (n.isDate(t))
      return t.toISOString();
    if (n.isBoolean(t))
      return t.toString();
    if (!A && n.isBlob(t))
      throw new p("Blob is not supported. Use a Buffer instead.");
    if (n.isArrayBuffer(t) || n.isTypedArray(t)) {
      if (A && typeof h == "function")
        return new h([t]);
      if (typeof Buffer < "u")
        return Buffer.from(t);
      throw new p("Blob is not supported. Use a Buffer instead.", p.ERR_NOT_SUPPORT);
    }
    return t;
  }
  function T(t) {
    if (t > a)
      throw new p(
        "Object is too deeply nested (" + t + " levels). Max depth: " + a,
        p.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function g(t, i) {
    if (a === 1 / 0)
      return JSON.stringify(t);
    const r = [];
    return JSON.stringify(t, function(d, o) {
      if (!n.isObject(o))
        return o;
      for (; r.length && r[r.length - 1] !== this; )
        r.pop();
      return r.push(o), T(i + r.length - 1), o;
    });
  }
  function x(t, i, r) {
    let l = t;
    if (n.isReactNative(s) && n.isReactNativeBlob(t))
      return s.append(E(r, i, u), b(t)), !1;
    if (t && !r && typeof t == "object") {
      if (n.endsWith(i, "{}"))
        i = B ? i : i.slice(0, -2), t = g(t, 1);
      else if (n.isArray(t) && S(t) || (n.isFileList(t) || n.endsWith(i, "[]")) && (l = n.toArray(t)))
        return i = F(i), l.forEach(function(o, j) {
          !(n.isUndefined(o) || o === null) && s.append(
            // eslint-disable-next-line no-nested-ternary
            O === !0 ? E([i], j, u) : O === null ? i : i + "[]",
            b(o)
          );
        }), !1;
    }
    return m(t) ? !0 : (s.append(E(r, i, u), b(t)), !1);
  }
  const R = Object.assign(U, {
    defaultVisitor: x,
    convertValue: b,
    isVisitable: m
  });
  function _(t, i, r = 0) {
    if (!n.isUndefined(t)) {
      if (T(r), w.indexOf(t) !== -1)
        throw new Error("Circular reference detected in " + i.join("."));
      w.push(t), n.forEach(t, function(d, o) {
        (!(n.isUndefined(d) || d === null) && c.call(s, d, n.isString(o) ? o.trim() : o, i, R)) === !0 && _(d, i ? i.concat(o) : [o], r + 1);
      }), w.pop();
    }
  }
  if (!n.isObject(e))
    throw new TypeError("data must be an object");
  return _(e), s;
}
export {
  D as DEFAULT_FORM_DATA_MAX_DEPTH,
  P as default
};
